import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from 'vue-lang-router'
import { createHead } from '@vueuse/head'
import { axios, axiosErrorHandler } from '@/utils/axios'
import event from '@/utils/event'
import vHtmlSanitized from './utils/vHtmlSanitized'
import { addQueryNavigation } from '@/utils/queryNavigation'
import tailwind from './tailwind'
import aos from 'aos'
import 'aos/dist/aos.css'
import CKEditor from '@ckeditor/ckeditor5-vue'

const app = createApp(App)
const head = createHead()

const aosConfig = {
  once: true,
  anchorPlacement: 'top-bottom' // TODO: doesn't work. Figure out why. In the meantime, specify on every element.
}
aos.init(aosConfig)

app.provide('$axios', axios)
app.provide('$axiosErrorHandler', axiosErrorHandler)
app.provide('$event', event)
app.provide('$aosRefresh', aos.refresh)
app.provide('$addQueryNavigation', addQueryNavigation)

app.use(store)
  .use(router)
  .use(i18n)
  .use(vHtmlSanitized)
  .use(CKEditor)
  .use(tailwind)
  .use(head)
  .mount('#app')

store.dispatch('fetchCurrentUser')
.catch(err => {
  // Shouldn't happen because fetchCurrentUser already handles exceptions and should return user null. Still, to be sure.
  console.error('Error fetching user:', err)
})

store.dispatch('fetchCurrentCustomer')
.catch(err => {
  // Shouldn't happen because fetchCurrentCustomer already handles exceptions and should return customer null. Still, to be sure.
  console.error('Error fetching customer:', err)
})